module.exports = __webpack_public_path__ + "img/file-import.d42a5bdd.png";